/**
 * clickgen-cta.js
 *
 * This is for the clickgen CTA that shows up on slideview for clickgen enables slideshows.
 * This file contains all the interactions with the CTA
 *
 * This also tracks impressions and clicks on these CTAs. Currently only one
 * impression is created per slide. So even if you hover over a slide multiple
 * times only one impression event it fired till you go to another slide and
 * come back.
 * Note: every impression event is unique and every impression event can have
 * multiple clicks associated with it.
 */
(function(win) {

  // Dependencies
  var $ = win.$,
    ss = win.slideshare_object,
    Experiments = ss.utils.imports('Experiments'),
    eventManager = $.slideshareEventManager,

    experiments = new Experiments(),
    clickgenCTAexperiment = 'slideview-clickgen-cta-2',
    isClickgenCTAExperimentBucketB = experiments.is(clickgenCTAexperiment, 'b'),

    selectors = {
      clickgenCTATop : '.clickgen-cta-top',
      clickgenCTA    : '.j-clickgen-cta',
      stage          : '.stage'
    },

    classes = {
      visible: 'visible'
    };

  /**
   * Creates a new ClickgenCTA instance
   * @constructor
   */
  function ClickgenCTA() {
    var impressionId,
      slide;
    if (!$.slideshareEventManager) {
      return;
    }

    this.$clickgenCTATop = $(selectors.clickgenCTATop);
    this.$clickgenCTA = this.$clickgenCTATop.find(selectors.clickgenCTA);
    this.clickgenTracker = eventManager.controller.clickGenTracker;

    // Add classes required for experiments
    experiments.addClass(selectors.clickgenCTA, clickgenCTAexperiment);

    if(ss.slideshow.is_clickgen_enabled && isClickgenCTAExperimentBucketB) {
      // Show the CTA for this bucket
      this.$clickgenCTA.addClass(classes.visible);

      // Track impression event
      slide = eventManager.controller.currentPosition;
      impressionId = this.clickgenTracker.trackLinkImpressionEvent(ss.slideshow.clickgen_url,
        this.clickgenTracker.LINK_TYPE.OverlaidCTA, slide);

      // Cache impression id for corresponding clicks
      this.impressionId = impressionId;

      // Cache slide number to avoid duplicate impressions
      this.lastSlideWithImpression = slide;

      this.bindEvents();
    }
  }

  ClickgenCTA.prototype = /** @lends ClickgenCTA.prototype */ {

    constructor: ClickgenCTA,

    /**
     * Binds all the events required for this CTA
     */
    bindEvents: function() {
      // Navigation to external link on click
      this.$clickgenCTA.off('click').on('click', function() {
        if(!this.impressionId) {
          // There should be no click without a prior impression
          return;
        }

        // Track click event
        this.clickgenTracker.trackLinkClickEvent(this.impressionId);

        // Navigate to external link
        win.open(ss.slideshow.clickgen_url, '_blank');
        win.focus();
      }.bind(this));

      /**
       * Show/Hide CTA while hovering over the content
       */
      $(selectors.stage).hover(function() {
        var impressionId,
          slide;

        if (this.$clickgenCTA.hasClass(classes.visible)) {
          // It is already visible, skip
          return;
        }

        // Make this CTA visible
        this.$clickgenCTA.addClass(classes.visible);

        // Track impression event if this is not a duplicate
        slide = eventManager.controller.currentPosition;

        if (slide != this.lastSlideWithImpression) {
          impressionId = this.clickgenTracker.trackLinkImpressionEvent(ss.slideshow.clickgen_url,
            this.clickgenTracker.LINK_TYPE.OverlaidCTA, slide);

          // Cache impression id for corresponding clicks
          this.impressionId = impressionId;

          // Cache slide number to avoid duplicate impressions
          this.lastSlideWithImpression = slide;
        }
      }.bind(this), function() {
        this.$clickgenCTA.removeClass(classes.visible);
      }.bind(this));


      /**
       * Hide CTA on initial slide change
       */
      if (eventManager.player) {
        eventManager.player.one('next previous gotoslide', function() {
          this.$clickgenCTA.removeClass(classes.visible);
        }.bind(this));
      }
    }
  };

  ss.utils.exports('clickgen.ClickgenCTA', ClickgenCTA);
}(window));
